import { DataStateChangeEvent } from "@progress/kendo-angular-grid";
import { PresetColumn, Preset } from "app/core/interfaces/preset";

import * as TrackerActions from "../actions/tracker.actions";

export interface IState {
    overdueWorkflowsCount: number;
    presetColumns: PresetColumn[];
    presetState: DataStateChangeEvent;
    selectedPresetIsModified: boolean;
    selectedPreset: Preset;
    totalDocumentsCount: number;
    totalWorkflowsCount: number;
    underReviewWorkflowsCount: number;
}

const initialState: IState = {
    overdueWorkflowsCount: 0,
    presetColumns: null,
    presetState: null,
    selectedPresetIsModified: false,
    selectedPreset: null,
    totalDocumentsCount: 0,
    totalWorkflowsCount: 0,
    underReviewWorkflowsCount: 0,
};

export const reducer = (
    state = initialState,
    action: TrackerActions.TrackerActions
): IState => {
    switch (action.type) {
        case TrackerActions.MODIFY_PRESET_COLUMNS:
            return {
                ...state,
                presetColumns: [...action.payload],
                selectedPresetIsModified: true,
            };

        case TrackerActions.MODIFY_PRESET_STATE:
            return {
                ...state,
                presetState: {
                    ...action.payload,
                },
                selectedPresetIsModified: true,
            };

        case TrackerActions.RESET_PRESET_MODIFIED_FLAG:
            return {
                ...state,
                selectedPresetIsModified: false,
            };

        case TrackerActions.SELECT_PRESET:
            return {
                ...state,
                presetColumns:
                    action.payload && action.payload.columns
                        ? [...action.payload.columns]
                        : [],
                presetState:
                    action.payload && action.payload.state
                        ? { ...action.payload.state }
                        : null,
                selectedPreset: {
                    ...action.payload,
                },
                selectedPresetIsModified: false,
            };

        case TrackerActions.SAVE_PRESET:
            return {
                ...state,
                selectedPreset: {
                    ...action.payload,
                },
                selectedPresetIsModified: false,
            };

        case TrackerActions.SET_DOCUMENTS_TOTAL_COUNT:
            return {
                ...state,
                totalDocumentsCount: action.payload,
            };

        case TrackerActions.SET_OVERDUE_WORKFLOWS_COUNT:
            return {
                ...state,
                overdueWorkflowsCount: action.payload,
            };

        case TrackerActions.SET_PRESET_COLUMNS:
            return {
                ...state,
                presetColumns: [...action.payload],
            };

        case TrackerActions.SET_UNDER_REVIEW_WORKFLOWS_COUNT:
            return {
                ...state,
                underReviewWorkflowsCount: action.payload,
            };

        case TrackerActions.SET_WORKFLOWS_TOTAL_COUNT:
            return {
                ...state,
                totalWorkflowsCount: action.payload,
            };

        default:
            return state;
    }
};
